export const RESULT_STATE = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

export const PROFILE_ACTION_NAME = 'PROFILE_WEBMETRICS';

export const PROFILE_SUBNAME = {
  WEBBALANCE: 'webBalance',
  WEBBENEFITSCORE: 'webBenefitScore',
  WEBENROLLMENT: 'webEnrollment',
  WEBFFNASSOCIATION: 'webFfnAssociation',
  WEBLOGIN: 'webLogin',
  WEBOTPASSNIP: 'webOtp',
  WEBUPGRADEVOUCHER: 'webUpgradeVoucher',
  WEBRECOVERACCOUNT: 'webRecoverAccount',
};

export const DEFAULT_NA = '*';

export const PROFILE_OTP_STEP = {
  OTP: 'send OTP',
  PASSWORD: 'password',
  NIP: 'NIP',
};

export const UPGRADE_VOUCHER_STEP = {
  GET: 'get Upgrade Voucher',
  POST: 'redeem Upgrade Voucher',
};